import { SyncEventType } from '../../enums/syncEventType';
import { RealtimeEvent } from './realtimeEvent';

export class EventSprintcardToForeground implements RealtimeEvent {

  public readonly type = SyncEventType.SPRINTECARD_TO_FOREGROUND;
  public sprintId: number;

  constructor(sprintId: number) {
    this.sprintId = sprintId;
  }

  getPayload(): object {
    const payload = {
      'sprintId': this.sprintId
    };
    return payload;
  }

  static fromPayload(payload: any): EventSprintcardToForeground {
    return new EventSprintcardToForeground(
      payload['sprintId']
    );
  }

}

